import React, { useEffect, useState } from 'react';
import {
    useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { HashRouter,
    Route,
    Routes,
    Navigate } from 'react-router-dom';
import {
  offline_enable,
  printDebugLog,
  setLoginResponse,
  test_environment_mode,
  detectBrowser,
  getOperatingSystem,
  SUCCESS
} from '../constants/constant';
import Dashboard from './dashboard/Dashboard';
import Login from './loginForm/Login';
import SsoLogin from './loginForm/SsoLogin';
import { setCartType, setActiveShopHash, setBaseCateogoryData, setBaseProductData } from "../actions";
import EcartWeb from './theme/EcartWeb';
import Admin from './admin/Admin';
import Signup from './admin/Signup';
// import PrintBill from './billing/PrintBill';
import CustomerBillSection from './billing/CustomerBillSection';
import ShortUrlToIframe from './theme/ShortUrlToIframe';
import LoginPage from './loginForm/LoginPage';
import Popup from './Popup';
import PrivacyPolicy from './PrivacyPolicy';
import GoldPdp from './goldcart/GoldPdp';
import OnlineWatchBill from './billing/onlinebilling/OnlineWatchBill';
import BillPdfWithPagination from './BillPdfWithPagination';

// class Routing extends React.Component {

const Routing = () => {

    // render() {
    const dispatch = useDispatch();
    const [restoringSession, setRestoringSession] = useState(Boolean(sessionStorage.getItem('a2zApiToken')));
    const authSession = useSelector(state => state.authSession);
    const storeApiUrl = useSelector(state => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL);

    const loadOfflineBillData = (loginData) => {
        const worker = new Worker(new URL('./billing/GetDataFromDbWorker.js', import.meta.url));
        worker.postMessage(loginData.activeShopHash.id);
        worker.postMessage("fullData");
        worker.onmessage = (e) => {
            let savedData = e.data;
            printDebugLog("getDataFromDb", savedData);
            if (savedData !== undefined && savedData.data !== undefined) {
                if ("fullData" === savedData.type) {
                    const dataMap = Object.fromEntries(savedData.data
                        .filter(item => item.id !== loginData.activeShopHash.id)
                        .map(item => [item.id, item.value]))
                        ;
                    printDebugLog("dataMap", dataMap)
                    dispatch(setBaseProductData(dataMap));
                } else {
                    dispatch(setBaseCateogoryData(savedData.data.value));
                }
            }
        };

        worker.onerror = (error) => {
            console.log("Worker error:", error);
        };
    };

    useEffect(() => {
        const token = sessionStorage.getItem('a2zApiToken');
        if (!token || authSession.loggedIn) {
            setRestoringSession(false);
            return;
        }
        axios.post(`${storeApiUrl.BACKEND_BASE_URL}web-session-restore`, {
            apiToken: token,
            deviceName: `${getOperatingSystem()},${detectBrowser()}`,
        }).then(response => {
            if (response.data.errCode !== SUCCESS) throw new Error('Session expired');
            setLoginResponse(response.data);
            dispatch(setCartType(response.data.cartType));
            dispatch(setActiveShopHash(response.data.activeShopHash));
            loadOfflineBillData(response.data);
        }).catch(error => {
            console.warn('Unable to restore session', error);
            sessionStorage.removeItem('a2zApiToken');
        }).finally(() => setRestoringSession(false));
    }, []);

    if (restoringSession) return null;





    return (
        <HashRouter>
            <Routes>
                <Route exact path="/login" element={<Login />} />
                <Route exact path="/print-bill" element={<Popup />} />
                <Route exact path="/gold-stock" element={<GoldPdp />} />
                <Route exact path="/test-online-bill" element={<OnlineWatchBill />} />
                {
                    offline_enable && <Route exact path="/sso-login" element={<SsoLogin />} />
                }
                <Route exact path="/dashboard/*" element={authSession.loggedIn ? <Dashboard /> : <Navigate replace to="/login" />} />
                <Route exact path="/coupon" element={authSession.loggedIn ? <Dashboard /> : <Navigate replace to="/login" />} />
                {
                    test_environment_mode && <Route exact path="/shorturltest" element={<ShortUrlToIframe />} />
                }
                {/* <Route exact path="/printBill" element={<PrintBill />} /> */}
                <Route exact path="/customer-bill-section" element={<CustomerBillSection />} />
                {
                    test_environment_mode && <Route exact path="/testsocket" element={<BillPdfWithPagination />} />
                }
                <Route exact path="/shop" element={<EcartWeb />} />
                <Route exact path="/admin-snp" element={<Admin />} />
                <Route exact path="/signup" element={<Signup />} />
                <Route exact path="/loginPage" element={<LoginPage />} />

                <Route exact path="/" element={
                    offline_enable ? <Navigate replace to="/sso-login" /> :
                        <Navigate replace to="/login" />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            </Routes>



            {/* <Route exact path="/error" element={
                        <Alert
                            severity={"error"}
                            alertcontent={"ERROR ALERT"}
                            alertDetail={"Something went wrong."}
                            alertSecondaryDetail={"Please try again after sometime."}
                        />} /> */}

        </HashRouter>
    );
}
// }


export default Routing;
